/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from '../config.service';
import { DeidLog } from '../shared/models/dicom.model';

@Injectable({
  providedIn: 'root',
})
export class DeidLogService {
  private deidLogUrl = this.configService?.apiConfig?.site?.deid_log_url;

  readonly logs = {
    post: (body: Partial<DeidLog>) => {
      return this.post<{ id: string }>(`${this.deidLogUrl}/logs`, body);
    },
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) { }

  post<T>(url: string, body?: any, options?: object): Observable<T> {
    return this.http.post<T>(url, body, options);
  }
}
